<div class="titulo-receber-cliente-view-modal modal fade modal-full-width modal-full-height">
    <div class="modal-dialog modal-dialog-scrollable">
        <div class="modal-content">
            <div class="modal-header">
                <h4 class="modal-title">
                    {{title}}
                </h4>
                <h6 class="modal-subtitle mb-0" *ngIf="cliente">
                    {{cliente.nomePessoa | clienteNome:cliente.nomeFantasiaPessoa:cliente.codigoIntegracaoErpPessoa}}
                </h6>                        
            </div>            
            <div class="modal-body" *ngIf="isOpen"> 
                <sgt-titulo-receber-table
                    #table
                    visualizacaoStorageKey="tituloReceberTableVisualizacaoClienteViewModal"
                    [clearVisualizacaoStorageKeyOnDestroy]="true"
                    [filter]="filter"
                    [optionsVisibility]="{
                        canEdit: true,
                        canVisualizar: true,
                        canImportOneErp: false,
                        canImportOneErp_v1: false
                    }"
                    (editTitulo)="editTitulo.emit($event)"
                    (visualizarTitulo)="visualizarTitulo.emit($event)">
                </sgt-titulo-receber-table>
            </div>
            <div class="modal-footer">           
                <button type="button" class="btn btn-light" (click)="close()">
                    <i class="fas fa-times"></i> Fechar
                </button>
            </div>            
        </div>
    </div>
</div>